module.exports = __webpack_public_path__ + "static/media/Flaticon2.b242ac81.woff";